<app-banner [heading]="'SCHOOL TIMINGS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="about" class="about">
	      <div class="container">
        <div class="row">
	
	



          <div class="col-lg-6 col-md-6">
            	<h1> Summers Timings </h1>
			<h4> Seniors :- 8:00 AM to 2:00PM <br> Kindergarten : 9:00 AM to 12:30 PM </h4>
		<br> <br>
		<h1> Winters Timings </h1>
			<h4> Seniors :- 9:00 AM to 2:30PM <br> Kindergarten : 10:00 AM to 01:00 PM </h4>
			<br> <h5>Closed on Sundays</h5>
	
             <!-- <img src="assets/img/comingsoon.jpg" alt="best school in kurukshetra"> -->
            </div>
          </div>

          
		</div>
      
	</section><!-- End About Section -->
	
		
			
    
	

	
	
    
    
  </main>